import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { searchIcon } from '../../../assets/icons';
import { TmBaseComponent } from '../../../tm-base.component';

export const tagName = 'tm-list-header-search-button';
@customElement(tagName)
export class TmListHeaderSearchButton extends TmBaseComponent {
    @state()
    private searching = false;

    @state()
    private shouldShowSearchField = false;

    private searchButton = createRef<HTMLButtonElement>();

    private resizeObserver = new ResizeObserver(() => {
        if (this.searchButton.value) {
            const displayStyle = window.getComputedStyle(this.searchButton.value).display;
            const searchButtonDisplayed = displayStyle !== 'none';
            this.shouldShowSearchField = searchButtonDisplayed && this.searching;
        } else {
            this.shouldShowSearchField = false;
        }
    });

    public connectedCallback(): void {
        super.connectedCallback?.();
        this.resizeObserver.observe(this);
    }

    public disconnectedCallback(): void {
        super.disconnectedCallback?.();
        this.resizeObserver.disconnect();
    }

    protected updated(_changedProperties: Map<PropertyKey, unknown>): void {
        if (_changedProperties.has('searching')) {
            this.shouldShowSearchField = this.searching;
        }
        if (_changedProperties.has('shouldShowSearchField')) {
            this.dispatchEvent(
                new CustomEvent('show-search-field', { detail: this.shouldShowSearchField })
            );
        }
    }

    protected render() {
        return html`<button
            ${ref(this.searchButton)}
            title="Search"
            class=${classMap({
                'search-button inline-block p-2.5': true,
                searching: this.searching,
            })}
            @click=${() => {
                this.searching = !this.searching;
            }}
        >
            ${searchIcon}
        </button>`;
    }

    public static get styles() {
        return [
            css`
                .search-button.searching path {
                    fill: var(--content-action);
                }

                .search-button path {
                    fill: var(--primary-text-color);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmListHeaderSearchButton;
    }
}
